import React from 'react';
import {
  Paper,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  Chip,
  Box,
  Stack
} from '@mui/material';
import { Student } from '@/types';

interface TopPerformersProps {
  students: Student[];
}

export const TopPerformers: React.FC<TopPerformersProps> = ({ students }) => {
  const topStudents = [...students]
    .sort((a, b) => b.attendanceRate - a.attendanceRate)
    .slice(0, 5);

  return (
    <Paper sx={{ 
      p: 3, 
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      minHeight: 480
    }}>
      <Typography variant="h6" component="div" gutterBottom>
        Top Attendance Performers
      </Typography>

      <List sx={{
        flexGrow: 1,
        '& > li:last-child': {
          borderBottom: 'none'
        }
      }}>
        {topStudents.map((student) => (
          <ListItem 
            key={student.id} 
            divider
            sx={{ py: 2 }}
          >
            <ListItemAvatar>
              <Avatar 
                src={student.photo}
                sx={{ 
                  width: 40, 
                  height: 40,
                  border: '2px solid',
                  borderColor: 'background.paper'
                }}
              />
            </ListItemAvatar>
            <Stack spacing={1} sx={{ flex: 1 }}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="subtitle2" component="span">
                  {`${student.firstName} ${student.lastName}`}
                </Typography>
                <Chip
                  label={`Grade ${student.grade}`}
                  size="small"
                  variant="outlined"
                />
              </Stack>
              <Stack spacing={0.5}>
                <Typography variant="body2" component="span" color="text.secondary">
                  Attendance rate: {student.attendanceRate}%
                </Typography>
                <Typography variant="body2" component="span" color="text.secondary">
                  Days present: {student.daysPresent}
                </Typography>
              </Stack>
            </Stack>
            <Chip
              label={`${student.attendanceRate}%`}
              color="success"
              size="small"
              sx={{ ml: 2 }}
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};